import LoggingService from 's2s-logging-service';
import objectMerge from 'object-merge';

const auth = (state={}, action)=>{
  //console.log('>>>>', state, action);

  switch (action.type) {
    case "AUTH_DATA":
      LoggingService.getInstance().debug('AUTH REDUCER --- AUTH_DATA');
      action.payload.timestamp = Date.now();
      return { ...state, ...action.payload};

    case "UPDATE_IDENTITY_PROPERTIES":
      {

        // Merge the updated properties into the auth state object and return it
        // as the new state
        const newState = objectMerge({}, state);
        newState.identitydata.properties = objectMerge({}, state.identitydata.properties, action.payload); 
        return newState;
      }

    default:
     return state;
    }
};

export { auth };



// WEBPACK FOOTER //
// ./src/reducers/auth-reducers.js